// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .disabled {
    pointer-events:none;
    
}
::ng-deep .mat-tree-node{
    min-height:20px !important;
}

button:focus {
    outline: 0px !important;
}
.struktur{
    background-color:#ff9e9e;
}
.cyber{
    background-color:#86c7f3;
}
.innotech{
    background-color:#ffd28c;
}
.krimisi{
    background-color:#a1ffb5;
}
.checklist-leaf-node{
    margin-left: 2em;
}
.checklist-branch-node > button{
    margin-left: 1.1em;
}

::ng-deep .cdk-overlay-container {
    font-size: 1rem !important;
}

::ng-deep .mat-mdc-tooltip {
    font-size: 1rem !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRhZy10cmVlLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxtQkFBbUI7O0FBRXZCO0FBQ0E7SUFLSSwwQkFBMEI7QUFIOUI7O0FBTUE7SUFDSSx1QkFBdUI7QUFDM0I7QUFDQTtJQUNJLHdCQUF3QjtBQUM1QjtBQUNBO0lBQ0ksd0JBQXdCO0FBQzVCO0FBQ0E7SUFDSSx3QkFBd0I7QUFDNUI7QUFDQTtJQUNJLHdCQUF3QjtBQUM1QjtBQUNBO0lBQ0ksZ0JBQWdCO0FBQ3BCO0FBQ0E7SUFDSSxrQkFBa0I7QUFDdEI7O0FBRUE7SUFDSSwwQkFBMEI7QUFDOUI7O0FBRUE7SUFDSSwwQkFBMEI7QUFDOUIiLCJmaWxlIjoidGFnLXRyZWUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIjo6bmctZGVlcCAuZGlzYWJsZWQge1xuICAgIHBvaW50ZXItZXZlbnRzOm5vbmU7XG4gICAgXG59XG46Om5nLWRlZXAgLm1hdC10cmVlLW5vZGV7XG4gICAgbWluLWhlaWdodDoyMHB4ICFpbXBvcnRhbnQ7XG59XG5cbjo6bmctZGVlcCAubWF0LXRyZWUtbm9kZXtcbiAgICBtaW4taGVpZ2h0OjIwcHggIWltcG9ydGFudDtcbn1cblxuYnV0dG9uOmZvY3VzIHtcbiAgICBvdXRsaW5lOiAwcHggIWltcG9ydGFudDtcbn1cbi5zdHJ1a3R1cntcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiNmZjllOWU7XG59XG4uY3liZXJ7XG4gICAgYmFja2dyb3VuZC1jb2xvcjojODZjN2YzO1xufVxuLmlubm90ZWNoe1xuICAgIGJhY2tncm91bmQtY29sb3I6I2ZmZDI4Yztcbn1cbi5rcmltaXNpe1xuICAgIGJhY2tncm91bmQtY29sb3I6I2ExZmZiNTtcbn1cbi5jaGVja2xpc3QtbGVhZi1ub2Rle1xuICAgIG1hcmdpbi1sZWZ0OiAyZW07XG59XG4uY2hlY2tsaXN0LWJyYW5jaC1ub2RlID4gYnV0dG9ue1xuICAgIG1hcmdpbi1sZWZ0OiAxLjFlbTtcbn1cblxuOjpuZy1kZWVwIC5jZGstb3ZlcmxheS1jb250YWluZXIge1xuICAgIGZvbnQtc2l6ZTogMXJlbSAhaW1wb3J0YW50O1xufVxuXG46Om5nLWRlZXAgLm1hdC1tZGMtdG9vbHRpcCB7XG4gICAgZm9udC1zaXplOiAxcmVtICFpbXBvcnRhbnQ7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/components/tag-tree/tag-tree.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;;AAEvB;AACA;IAKI,0BAA0B;AAH9B;;AAMA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;AAHA,g7CAAg7C","sourcesContent":["::ng-deep .disabled {\n    pointer-events:none;\n    \n}\n::ng-deep .mat-tree-node{\n    min-height:20px !important;\n}\n\n::ng-deep .mat-tree-node{\n    min-height:20px !important;\n}\n\nbutton:focus {\n    outline: 0px !important;\n}\n.struktur{\n    background-color:#ff9e9e;\n}\n.cyber{\n    background-color:#86c7f3;\n}\n.innotech{\n    background-color:#ffd28c;\n}\n.krimisi{\n    background-color:#a1ffb5;\n}\n.checklist-leaf-node{\n    margin-left: 2em;\n}\n.checklist-branch-node > button{\n    margin-left: 1.1em;\n}\n\n::ng-deep .cdk-overlay-container {\n    font-size: 1rem !important;\n}\n\n::ng-deep .mat-mdc-tooltip {\n    font-size: 1rem !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
